/** Festes Präfix P-, danach nur Ziffern. Beispiel: P-0042. */
export const PROJEKTNUMMER_PATTERN = /^P-[0-9]{1,30}$/;

export function projektnummerFehler(value: string, showEmpty: boolean): string {
  const trimmed = value.trim();
  if (!trimmed) {
    return showEmpty ? 'Projektnummer ist erforderlich (z. B. P-0042).' : '';
  }
  if (!trimmed.startsWith('P-')) {
    return 'Projektnummer muss mit dem festen Präfix P- beginnen (z. B. P-0042).';
  }
  if (!PROJEKTNUMMER_PATTERN.test(trimmed)) {
    return 'Nach P- sind nur Ziffern erlaubt (z. B. P-0042).';
  }
  return '';
}
